import { coreApi } from '../api'
import { DocumentListProps, AttributesProps } from '../documents'

interface PeopleDocumentsProps {
  residenceProof: AttributesProps
  incomeProof: AttributesProps
  identityProof: AttributesProps
}

async function fetchData(applicationId: string): Promise<PeopleDocumentsProps> {
  const { data: response } = await coreApi.get<DocumentListProps>(
    `/loan/auto-refi/bkf/people/${applicationId}/documents`,
  )

  function filterDocument(key: string): AttributesProps {
    const filteredDocuments = response.data.filter(
      doc => doc.attributes.name === key,
    )
    const document = filteredDocuments[0]
    return {
      name: document?.attributes.name,
      status: document?.attributes.status,
    }
  }

  return {
    residenceProof: filterDocument('residence_proof'),
    incomeProof: filterDocument('income_proof'),
    identityProof: filterDocument('identity_document'),
  }
}

export { fetchData }
